import { Text, View } from "@react-pdf/renderer";
import Helper from "../functions/Helper";

export default function PDFText(props) {
  let coordinates = Helper.getMaxCoordinates(props.court);

  let {
    x: posX,
    y: posY,
    width: tempWidth,
    height: tempHeight,
  } = Helper.convertRectToSVG(
    props.pos[0],
    props.pos[1],
    props.width,
    props.height,
    props.court.full
  );

  let left = ((posX - coordinates.minX) / coordinates.viewBoxWidth) * 100 + "%";
  let top = ((posY - coordinates.minY) / coordinates.viewBoxHeight) * 100 + "%";
  let width = (tempWidth / coordinates.viewBoxWidth) * 100 + "%";
  let height = (tempHeight / coordinates.viewBoxHeight) * 100 + "%";
  let pixelPerFoot = props.frameWidth / coordinates.viewBoxWidth;
  let padding = `${pixelPerFoot / 2}px ${pixelPerFoot * 1.5}px`;

  return (
    <View
      style={{
        transform: `rotate(${props.angle}deg)`,
        padding: padding,
        flexDirection: "row",
        justifyContent: props.alignment,
        alignItems: props.verticalAlignment,
        display: "flex",
        position: "absolute",
        top: top,
        left: left,
        width: width,
        height: height,
        backgroundColor: props.backgroundColor,
      }}
    >
      <Text
        style={{
          width: "100%",
          display: "flex",
          color: props.color,
          fontSize:
            ((props.frameWidth / coordinates.viewBoxWidth) * props.fontSize) /
            10,
          textAlign: props.alignment,
          fontStyle: props.formats.includes("italic") ? "italic" : "normal",
          textDecoration: props.formats.includes("underline")
            ? "underline"
            : "none",
          fontWeight: props.formats.includes("bold") ? "bold" : "normal",
        }}
      >
        {props.text}
      </Text>
    </View>
  );
}
